import api from '../api';

export const fetchAudio = async (srcId: string) => {
  try {
    const { data } = await api.get(`audio/${srcId}`);
  
    return data.audioDesc;
  } catch(error: any) {
    console.error(error.message);
  }
};

